import { css } from "@emotion/react";
import { constants } from "@newsela/angelou";

const coreBlue = constants.colors.ui.core[600];
/** Styles for See More Wrapper */
export const seeMoreStyle = css`
  color: ${coreBlue};
  ${constants.legacy_typography.family.circular.styles};
  ${constants.legacy_typography.size.S.styles};
  display: flex;
  font-weight: bold;
  justify-content: flex-end;
  margin-top: 1.25rem;
  margin-left: auto;
  margin-right: 2px;
  text-decoration: none;
  width: fit-content;
  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;
